import { createSlice } from '@reduxjs/toolkit';

const JewellerSlice = createSlice({
  name: 'jeweller',
  initialState: {
    jewellers: [],
    total: 0,
    loading: false,
    message: '',
    messageType: '',
    instalaxmiUsers: [],
    createdJewellerId: null,
  },
  reducers: {
    // FETCH
    fetchJewellersRequest: (state) => {
      state.loading = true;
      state.message = null;
      state.messageType = null;
    },
    fetchJewellersSuccess: (state, action) => {
      state.loading = false;
      state.jewellers = action.payload.data;
      state.total = action.payload.total;
    },
    fetchJewellersFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
      state.messageType = action.payload.type;
    },
    //
    fetchJewellersSidebarRequest: (state) => {
      state.loading = true;
    },
    fetchJewellersSidebarSuccess: (state, action) => {
      state.loading = false;
      state.jewellersSidebar = action.payload;
    },

    // CREATE
    createJewellerRequest: (state) => {
      state.loading = true;
      state.message = null;
      state.messageType = null;
      state.createdJewellerId = null;
    },
    createJewellerSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
      state.messageType = action.payload.type;
      state.createdJewellerId = action.payload.jeweller?._id || null;
    },
    createJewellerFailure: (state, action) => {
      let rawMessage = action.payload?.message || 'Something went wrong';
      // Clean long object log from message
      const cleanedMessage = rawMessage.split('with')[0]?.trim() || rawMessage;

      state.message = cleanedMessage;
      state.messageType = action.payload?.type || 'error';
    },

    // EDIT
    editJewellerRequest: (state) => {
      state.loading = true;
      state.message = null;
      state.messageType = null;
    },
    editJewellerSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
      state.messageType = action.payload.type;
    },
    editJewellerFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
      state.messageType = action.payload.type;
    },

    // DELETE
    deleteJewellerRequest: (state) => {
      state.loading = true;
      state.message = null;
      state.messageType = null;
    },
    deleteJewellerSuccess: (state, action) => {
      state.loading = false;
      state.jewellers = state.jewellers.filter(
        (j) => j._id !== action.payload.id,
      );
      state.message = action.payload.message;
      state.messageType = action.payload.type;
    },
    deleteJewellerFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
      state.messageType = action.payload.type;
    },

    // RESET
    resetJewellerMessages: (state) => {
      state.message = null;
      state.messageType = null;
    },

    fetchInstalaxmiUsersRequest: (state) => {
      state.loading = true;
      state.message = null;
      state.messageType = null;
    },
    fetchInstalaxmiUsersSuccess: (state, action) => {
      state.loading = false;
      state.instalaxmiUsers = action.payload;
    },
    fetchInstalaxmiUsersFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
      state.messageType = action.payload.type;
    },
    resetCreatedJewellerId: (state) => {
      state.createdJewellerId = null;
    },
  },
});

export const {
  fetchJewellersRequest,
  fetchJewellersSuccess,
  fetchJewellersFailure,
  fetchJewellersSidebarRequest,
  fetchJewellersSidebarSuccess,
  createJewellerRequest,
  createJewellerSuccess,
  createJewellerFailure,
  editJewellerRequest,
  editJewellerSuccess,
  editJewellerFailure,
  deleteJewellerRequest,
  deleteJewellerSuccess,
  deleteJewellerFailure,
  resetJewellerMessages,
  fetchInstalaxmiUsersRequest,
  fetchInstalaxmiUsersSuccess,
  fetchInstalaxmiUsersFailure,
  resetCreatedJewellerId,
} = JewellerSlice.actions;

export default JewellerSlice.reducer;
